"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plank = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../assets/js/constants");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Plank = _styledComponents["default"].div.withConfig({
  displayName: "styled__Plank",
  componentId: "z3papv-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: 20px 30px;\n    background-color: ", ";\n    border-radius: 4px;\n    display: block;\n"])), _constants.COLORS.lightPink);

exports.Plank = Plank;